import { render, staticRenderFns } from "./newTab.vue?vue&type=template&id=d66f5988&scoped=true&"
import script from "./newTab.vue?vue&type=script&lang=js&"
export * from "./newTab.vue?vue&type=script&lang=js&"
import style0 from "./newTab.vue?vue&type=style&index=0&id=d66f5988&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66f5988",
  null
  
)

export default component.exports